import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideClientSearchLib } from '@howdeniberia/client-search';
import {
  IHowdenEnvironment,
  IPackageJsonWrapper,
  provideHowdenCore
} from '@howdeniberia/core-front';
import { ApiConfigurations } from 'src/environments/api-configurations';
import packageJson from '../../package.json';
import { environment } from '../environments/environment';
import { AppRoutes } from './app-routing';
import { provideCoreServices } from './core/core.provider';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(AppRoutes),
    provideCoreServices(),
    provideClientSearchLib(),
    provideHowdenCore({
      environment: environment as IHowdenEnvironment,
      packageJson: packageJson as unknown as IPackageJsonWrapper,
      apiConfigurations: ApiConfigurations
    })
  ]
};
